import 'sumoselect';
import 'sumoselect/sumoselect.css';
import $ from 'jquery';


// if (window.location.pathname  === '/') {
    document.addEventListener('DOMContentLoaded', function () {
        const markaSelect = document.getElementById('marka');
        const modelSelect = document.getElementById('model');
        const allSelects = document.querySelectorAll('.select-input');
        const homepageForm = document.querySelector('.home-forms');
        const removeFilters = document.querySelector('.remove-all-filters');
        const modelContainer = modelSelect.parentElement;
        const select = $('#model');
        const formSearch = document.querySelector('.home-forms__section--search-vehicle');
        const submitButton = formSearch.querySelector('.button-type-1');

        submitButton.addEventListener('click', function () {
            if (markaSelect.value && markaSelect.value !== '0') {
                sessionStorage.setItem('selectedMarka', markaSelect.value);
            }
            const selectedModels = $(modelSelect).val() || [];
            if (selectedModels.length > 0) {
                sessionStorage.setItem('selectedModels', JSON.stringify(selectedModels));
            }
            allSelects.forEach(selectInput => {
                if (selectInput.name !== 'marka' && selectInput.value && selectInput.value !== '0') {
                    sessionStorage.setItem(selectInput.name, selectInput.value);
                }
            });
        })

        modelSelect.innerHTML = '<option value="" selected disabled>Model</option>';
        modelSelect.disabled = true;
        if ($) {
            if (!select[0].sumo) {
                select.SumoSelect({
                    placeholder: 'Model',
                    search: true,
                    searchText: 'Pretraga...',
                    selectAll: true,
                    okCancelInMulti: false,
                    noMatch: 'Nema rezultata',
                    locale: ['OK', 'Otkaži', 'Odaberi sve/Poništi'],
                    csvDispCount: 3,
                    // captionFormat: 'Odabrano: {0}', // 3+ stavki = Odabrano: n
                    captionFormatAllSelected: 'Odabrano: {0}',
                    forceCustomRendering: true,
                });
                if (homepageForm) {
                    // modelContainer.style.opacity = '1';
                    modelContainer.classList.add('show');
                }
            }
        }


        const sumo = select[0].sumo;
        const savedModels = JSON.parse(sessionStorage.getItem('selectedModels') || '[]');
        const savedMarka = sessionStorage.getItem('selectedMarka');

        if (savedModels.length > 0) {
            sumo.selectItem(savedModels);
        }

        const allMarks = markaSelect.querySelector('#all_marks');

        allMarks.addEventListener('click', function () {
            modelSelect.innerHTML = '<option value="" selected disabled>Model</option>';
            modelSelect.disabled = true;
            select[0].sumo.reload();
        });

        if (savedMarka && savedMarka !== '0') {
            markaSelect.value = savedMarka;
            loadModels(savedMarka, savedModels);
        } else if (markaSelect.value && markaSelect.value !== '0') {
            loadModels(markaSelect.value, savedModels);
        }

        markaSelect.addEventListener('change', function () {
            const markaId = this.value;

            if (markaId && markaId !== '0') {
                loadModels(markaId, []);
            }
        });

        modelSelect.addEventListener('change', function () {
            const selectedValues = Array.from(modelSelect.selectedOptions).map(o => String(o.value));
            // sessionStorage.setItem('selectedModels', JSON.stringify(selectedValues));
        });

        allSelects.forEach(selectInput => {
            selectInput.addEventListener('change', function () {
                if (selectInput.name != 'marka'){
                    // sessionStorage.setItem(selectInput.name, selectInput.value);
                }
            });
            const selectValue = sessionStorage.getItem(selectInput.name);
            if (selectValue && selectValue !== '0') {
                selectInput.value = selectValue;
            }
            selectInput.addEventListener('focus', () => {
                if (modelSelect.parentElement.classList.contains('open')) {
                    modelSelect.parentElement.classList.remove('open');
                    modelSelect.parentElement.ariaExpanded = 'false';
                }
            });
        })

        function loadModels(markaId, preselectModelIds = []) {
            modelSelect.innerHTML = '<option value="" disabled>Učitavam...</option>';
            modelSelect.disabled = true;

            fetch(`/vehicles/models/${markaId}`)
                .then(r => r.json())
                .then(data => {
                    if (!data.success) throw new Error(data.message || 'Greška pri učitavanju modela');

                    // isprazni select i dodaj opcije
                    modelSelect.innerHTML = '';

                    const preselectedSet = new Set((preselectModelIds || []).map(String));

                    data.data.forEach(m => {
                        const opt = document.createElement('option');
                        opt.value = String(m.id);
                        opt.textContent = m.title;
                        if (preselectedSet.has(String(m.id))) opt.selected = true;
                        modelSelect.appendChild(opt);
                    });

                    modelSelect.disabled = false;

                    // Inicijalizuj ili reload-uj SumoSelect POSLE što si dodao opcije
                    if ($) {
                        const el = $('#model')[0];
                        if (el && el.sumo) {
                            el.sumo.reload(); // osveži listu
                        } else {
                            select.SumoSelect({
                                placeholder: 'Model',
                                search: true,
                                searchText: 'Pretraga...',
                                selectAll: true,
                                captionFormatAllSelected: 'Označi sve',
                                okCancelInMulti: false,
                                noMatch: 'Nema rezultata',
                                locale: ['OK', 'Otkaži', 'Odaberi sve/Poništi'],
                                csvDispCount: 2, // 1-2 naziva, zatim "+n" (Sumo-ov default prikaz)
                            });
                        }
                    }
                })
                .catch(err => {
                    console.error('Greška:', err);
                    modelSelect.innerHTML = '<option value="" disabled>Greška pri učitavanju</option>';
                    // Ako je već postojao Sumo, samo reload da prikaže poruku
                    if ($) {
                        const el = $('#model')[0];
                        if (el && el.sumo) el.sumo.reload();
                    }
                });
        }


        // Reset svih polja
        if (removeFilters) {
            removeFilters.addEventListener('click', function () {

                allSelects.forEach(select => {
                    sessionStorage.removeItem(select.name, select.value);
                    select.selectedIndex = 0;
                })

                sessionStorage.removeItem('selectedMarka');
                sessionStorage.removeItem('selectedModels');
                sessionStorage.removeItem('sort');
                const menuItem = document.getElementById('ponuda_menu_item');
                menuItem.href = '/ponuda';

                markaSelect.selectedIndex = 0;
                modelSelect.innerHTML = '<option value="" selected disabled>Model</option>';
                modelSelect.disabled = true;
                select[0].sumo.reload();
            });
        }
    });



// }
